import dynamic from 'next/dynamic'
import { useRouter } from 'next/router'
import { getPostAndMorePosts, getBreadcrumbs, getDaughter, getAllPostsWithSlug, getMotherAndSister, getAllMarques } from '../lib/api'

const ErrorPage = dynamic(() => import('next/error'))
const PageTemplate = dynamic(() => import('../components/page-template'))


export const config = { amp: false }


export default function Page({article, breadcrumbs, daughter,motherAndSister, moreArticle, preview, siteEnv, marques}){
    const router = useRouter()
    /* const Asset = ({ children }) => <figure>
      <div>{"Show : ", children}</div>
      <img alt="La technologie optimisant le chargement des Progressive Web Apps" src={children.url+"?fm=webp&q=60"} />
      <figcaption>Voici la technologie optimisant les temps de chargement des progressive web apps <a href="https://developers.google.com/web/updates/2015/11/app-shell#performance-benefits">Source Google Developers</a></figcaption>
    </figure>; */
    //console.log(article)
    // loop through the linked assets and add them to a map
    
    
    if (!router.isFallback && !article) {
      return <ErrorPage statusCode={404} />
    }


    return (
      <>
      {router.isFallback ? (
        <div>Loading…</div>
      ) : (
          <>
          <PageTemplate preview={preview} breadcrumbs={breadcrumbs} daughter={daughter} motherAndSister={motherAndSister} article={article} moreArticle={moreArticle} siteEnv={siteEnv} marques={marques}></PageTemplate>
        </>
      )}
      </>
    )
}  

export async function getStaticProps({ params, preview = false }) {
  
  const siteEnv = process.env.CONTENTFUL_SITE_TAG ?? "pwafr"

  if( params && params.page && params?.page.length > 1){
      params.page = params.page.join("/");
  }else{
      params.page = params.page[0];
  }
  
  const data = (await getPostAndMorePosts(params.page, preview)) ?? []
  const breadcrumbs = (await getBreadcrumbs(params.page, preview)) ?? []
  const daughter = (await getDaughter('/'+params.page, preview)) ?? []
  const motherAndSister = (await getMotherAndSister(params.page, preview)) ?? []
  const marques = (await getAllMarques(preview)) ?? []

  



  return {
    props: {
      preview,
      article: data?.article ?? null,
      breadcrumbs: breadcrumbs ?? null,
      daughter,
      motherAndSister : motherAndSister,
      moreArticle: data?.moreArticle ?? null,
      siteEnv,
      marques
      
    },
    revalidate: 10,
  }
}

export async function getStaticPaths() {
  const allPosts = await getAllPostsWithSlug()
  
  return {
    paths: allPosts?.map(({ url }) => `${url}`) ?? [],
    fallback: false,
  }
}